import React from 'react';
import {
  FormGroup,
  ControlLabel,
  Button,
  ButtonGroup,
  FormControl,
  HelpBlock,
  Table,
  Row,
  Col
} from 'react-bootstrap';
import { Checkbox } from 'components';

class PlansDiscountForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      adding_discount: false,
      new_discount_props: { min: '', max: '', amount: '', infinite_max: false },
      editing_discount_idx: null,
      editing_discount_props: { min: '', max: '', amount: '', infinite_max: false },
      min_value_error: false,
      max_value_error: false,
      amount_value_error: false,
      min_error_message: '',
      max_error_message: '',
      amount_error_message: '',
      infinite_max_error: false
    };

    this.handleClickEditDiscount = this.handleClickEditDiscount.bind(this);
    this.handleMinChange = this.handleMinChange.bind(this);
    this.handleMaxChange = this.handleMaxChange.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleToggleInfiniteMax = this.handleToggleInfiniteMax.bind(this);
    this.handleSaveDiscount = this.handleSaveDiscount.bind(this);
    this.handleCancelAddNewDiscount = this.handleCancelAddNewDiscount.bind(this);
    this.handleCancelEditDiscount = this.handleCancelEditDiscount.bind(this);
    this.renderDiscount = this.renderDiscount.bind(this);
  }

  handleClickEditDiscount(idx) {
    const { min, max, amount } = this.props.discounts[idx];
    this.setState({
      editing_discount_idx: idx,
      editing_discount_props: { min, max, amount, infinite_max: max == null }
    });
  }
  handleMinChange(event, idx) {
    let new_discount_props, editing_discount_props;
    if(this.state.adding_discount) {
      new_discount_props = { ...this.state.new_discount_props, min: event.target.value };
      editing_discount_props = this.state.editing_discount_props;
    }
    else {
      new_discount_props = this.state.new_discount_props;
      editing_discount_props = { ...this.state.editing_discount_props, min: event.target.value };
    }
    this.setState({
      new_discount_props,
      editing_discount_props,
      min_value_error: false,
      min_error_message: ''
    });
  }
  handleMaxChange(event, idx) {
    let new_discount_props, editing_discount_props;
    if(this.state.adding_discount) {
      new_discount_props = { ...this.state.new_discount_props, max: event.target.value };
      editing_discount_props = this.state.editing_discount_props;
    }
    else {
      new_discount_props = this.state.new_discount_props;
      editing_discount_props = { ...this.state.editing_discount_props, max: event.target.value };
    }
    this.setState({
      new_discount_props,
      editing_discount_props,
      max_value_error: false,
      max_error_message: ''
    });
  }
  handleAmountChange(event, idx) {
    let new_discount_props, editing_discount_props;
    if(this.state.adding_discount) {
      new_discount_props = { ...this.state.new_discount_props, amount: event.target.value };
      editing_discount_props = this.state.editing_discount_props;
    }
    else {
      new_discount_props = this.state.new_discount_props;
      editing_discount_props = { ...this.state.editing_discount_props, amount: event.target.value };
    }
    this.setState({
      new_discount_props,
      editing_discount_props,
      amount_value_error: false,
      amount_error_message: ''
    });
  }
  handleToggleInfiniteMax(idx) {
    let new_discount_props, editing_discount_props;
    if(this.state.adding_discount) {
      new_discount_props = {
        ...this.state.new_discount_props,
        infinite_max: !this.state.new_discount_props.infinite_max
      };
      editing_discount_props = this.state.editing_discount_props;
    }
    else {
      editing_discount_props = {
        ...this.state.editing_discount_props,
        infinite_max: !this.state.editing_discount_props.infinite_max
      };
    }
    this.setState({ new_discount_props, editing_discount_props });
  }
  handleSaveDiscount() {
    const { adding_discount, new_discount_props, editing_discount_props } = this.state;
    const { min, max, amount, infinite_max } = adding_discount ? new_discount_props : editing_discount_props;
    let
      min_value_error = false,
      min_error_message = '',
      max_value_error = false,
      max_error_message = '',
      amount_value_error = false,
      amount_error_message = '';
    if(min == '') {
      min_value_error = true;
      min_error_message = 'Must include a minimum value';
    }
    if(+min < 0) {
      min_value_error = true;
      min_error_message = 'Min value must be non-negative';
    }
    if(max == '' && !infinite_max) {
      max_value_error = true;
      max_error_message = 'Must include a maximum value';
    }
    if(+min < 0) {
      min_value_error = true;
      min_error_message = 'Max value must be non-negative';
    }
    if(amount == '') {
      amount_value_error = true;
      amount_error_message = 'Must include an amount';
    }
    if(!amount_value_error && amount <= 0) {
      amount_value_error = true;
      amount_error_message = 'Amount must be a positive non-zero value';
    }
    if(!max_value_error && !infinite_max && +max <= +min) {
      max_value_error = true;
      max_error_message = 'Max value must be larger than min value';
    }
    if(!min_value_error) {
      const min_range_error = this.props.discounts.find((d, i) => {
        return (
          (adding_discount ? true : i != this.state.editing_discount_idx) &&
          +min >= +d.min &&
          (d.max == null || +min <= +d.max)
        );
      });
      if(min_range_error) {
        min_value_error = true;
        min_error_message = 'Crossing range found with another discount. Ranges cannot overlap';
      };
    }
    if(!max_value_error) {
      const max_range_error = this.props.discounts.find((d, i) => {
        return (
          !infinite_max &&
          (adding_discount ? true : i != this.state.editing_discount_idx) &&
          +max >= +d.min &&
          (d.max == null || +max <= +d.max)
        );
      });
      if(max_range_error) {
        max_value_error = true;
        max_error_message = 'Crossing range found with another discount. Ranges cannot overlap';
      }
    }
    if(!min_value_error && !max_value_error && !amount_value_error) {
      if(adding_discount) {
        this.props.handleAddDiscount(new_discount_props);
      }
      else {
        this.props.handleEditDiscount(this.state.editing_discount_idx, editing_discount_props);
      }
      this.setState({
        adding_discount: false,
        new_discount_props: { min: '', max: '', amount: '', infinite_max: false },
        editing_discount_idx: null,
        editing_discount_props: { min: '', max: '', amount: '', infinite_max: false },
        min_value_error: false,
        min_error_message: '',
        max_value_error: false,
        max_error_message: '',
        amount_value_error: false,
        amount_error_message: '',
      });
    }
    else {
      this.setState({
        min_value_error,
        min_error_message,
        max_value_error,
        max_error_message,
        amount_value_error,
        amount_error_message
      });
    }
  }
  handleCancelAddNewDiscount() {
    this.setState({
      adding_discount: false,
      min_value_error: false,
      max_value_error: false,
      amount_value_error: false,
      min_error_message: '',
      max_error_message: '',
      amount_error_message: '',
      new_discount_props: { min: '', max: '', amount: '', infinite_max: false }
    });
  }
  handleCancelEditDiscount() {
    this.setState({
      editing_discount_idx: null,
      editing_discount_props: { min: '', max: '', amount: '', infinite_max: false },
      min_value_error: false,
      max_value_error: false,
      amount_value_error: false,
      min_error_message: '',
      max_error_message: '',
      amount_error_message: '',
    });
  }
  renderDiscount(discount, idx, is_new_discount) {
    const infinite_max = is_new_discount ? this.state.new_discount_props.infinite_max : this.state.editing_discount_props.infinite_max;
    const modifying_current_discount = (this.state.adding_discount && is_new_discount) || (this.state.editing_discount_idx == idx);
    const min_value_error = this.state.min_value_error && modifying_current_discount;
    const max_value_error = this.state.max_value_error && modifying_current_discount;
    const amount_value_error = this.state.amount_value_error && modifying_current_discount;

    return modifying_current_discount ? (
      <tr key={idx}>
        <td>
          <FormGroup validationState={this.state.min_value_error ? 'error' : null}>
            <FormControl
              value={discount.min}
              onChange={e => this.handleMinChange(e, idx)}
              type='number'
              min='0'
              autoFocus
            />
            {min_value_error ? <HelpBlock>{this.state.min_error_message}</HelpBlock> : null}
          </FormGroup>
        </td>
        <td>
          {this.props.discounts.find(d => d.max == null) == null ? (
            <FormGroup validationState={this.state.max_value_error ? 'error' : null}>
              <Row>
                <Col md={6} xs={6}>
                  <FormControl
                    value={infinite_max ? '' : discount.max}
                    onChange={e => this.handleMaxChange(e, idx)}
                    type='number'
                    min='0'
                    disabled={infinite_max}
                  />
                </Col>
                <Col md={6} xs={6} style={{ textAlign: 'left' }}>
                  <h6 style={{ margin: '0 0 0 0' }}>Infinite Max</h6>
                  <Checkbox
                    id='plan-creator-ininite-max-checkbox'
                    onChange={() => this.handleToggleInfiniteMax(idx)}
                    checked={infinite_max}
                    value='on'
                  />
                </Col>
              </Row>
              {max_value_error ? <HelpBlock>{this.state.max_error_message}</HelpBlock> : null}
            </FormGroup>
          ) : (
            <FormGroup validationState={this.state.max_value_error ? 'error' : null}>
              <FormControl
                value={discount.max}
                onChange={e => this.handleMaxChange(e, idx)}
                type='number'
                min='0'
              />
              {max_value_error ? <HelpBlock>{this.state.max_error_message}</HelpBlock> : null}
            </FormGroup>
          )}
        </td>
        <td>
          <FormGroup validationState={this.state.amount_value_error ? 'error' : null}>
            <FormControl
              value={discount.amount}
              onChange={e => this.handleAmountChange(e, idx)}
              type='number'
              min='0'
            />
            {amount_value_error ? <HelpBlock>{this.state.amount_error_message}</HelpBlock> : null}
          </FormGroup>
        </td>
        <td>
          <Button
            onClick={this.handleSaveDiscount}
            bsStyle='success'
            block
            style={{ marginTop: '0px' }}
            >
            <i className='fa fa-check' />
          </Button>
        </td>
      </tr>
    ) : (
      <tr key={idx}>
        <td>{discount.min}</td>
        <td>{discount.max == null ? 'Infinite' : discount.max}</td>
        <td>{discount.amount}</td>
        <td>
          <ButtonGroup justified>
            <Button
              onClick={() => this.handleClickEditDiscount(idx)}
              bsStyle='warning'
              >
              <i className='fa fa-pencil' />
            </Button>
            <Button
              onClick={() => this.props.handleRemoveDiscount(idx)}
              bsStyle='danger'
              >
              <i className='fa fa-minus' />
            </Button>
          </ButtonGroup>
        </td>
      </tr>
    );
  }

  render() {
    return (
      <FormGroup>
        <ControlLabel>
          Plan Discounts
        </ControlLabel>
        <Table
          striped bordered fill
          bsClass='plans-form-discounts-table'
          >
          <thead>
            <tr>
              <th>Min</th>
              <th>Max</th>
              <th>Amount</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.props.discounts.map((d, idx) => {
              if(!this.state.adding_discount && this.state.editing_discount_idx == idx) {
                return this.renderDiscount(this.state.editing_discount_props, idx)
              }
              else {
                return this.renderDiscount(d, idx);
              }
            })}
            {this.state.adding_discount ? (
              this.renderDiscount(this.state.new_discount_props, null, true)
            ) : null}
          </tbody>
        </Table>
        {this.state.adding_discount || this.state.editing_discount_idx != null? (
          <Button
            onClick={this.state.adding_discount ? this.handleCancelAddNewDiscount : this.handleCancelEditDiscount}
            block
            >
            <i className='fa fa-times' />{'  '}Cancel
          </Button>
        ) : (
          <Button
            block
            bsStyle='success'
            onClick={() => this.setState({ adding_discount: true })}
            >
            <i className='fa fa-plus' />{'  '}Add New Discount
          </Button>
        )}
      </FormGroup>
    );
  }
}

export default PlansDiscountForm;



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/plans/plans-discount-form.js